import { AxiosPromise, AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';
import { camelizeObject, snakizeObject } from '@cvt/helpers/object';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const getFunFacts = (params: FunFacts.GetListParams): AxiosPromise<CVT.Query.PaginatedResults<FunFacts.FunFact>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/fun-facts/`,
      method: 'GET',
      params: snakizeObject(params),
    },
  }).then((data: AxiosResponse<CVT.Query.PaginatedResults<FunFacts.FunFactApi>>) => ({
    ...data,
    data: {
      ...camelizeObject(data.data),
      results: data.data.results.map((result) => camelizeObject(result)),
    },
  }));
};


export const funFactClient = {
  getFunFacts,
};
